import api from '../utils/api'; // Assuming you have an API utility

const userService = {
  // User CRUD
  getUsers: (params) => api.get('/admin/users', { params }),
  getUser: (id) => api.get(`/admin/users/${id}`),
  createUser: (data) => api.post('/admin/users', data),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  
  // User Actions
  toggleUserStatus: (id, isActive) => api.patch(`/admin/users/${id}/status`, { isActive }),
  resetUserPassword: (id) => api.post(`/admin/users/${id}/reset-password`),
  verifyUser: (id) => api.post(`/admin/users/${id}/verify`),
  
  // User Roles
  assignRoles: (id, roleIds) => api.post(`/admin/users/${id}/roles`, { roleIds }),
  getUserRoles: (id) => api.get(`/admin/users/${id}/roles`),
  
  // Activity & Statistics
  getUserActivity: (id, params) => api.get(`/admin/users/${id}/activity`, { params }),
  getUserHierarchy: (id) => api.get(`/admin/users/${id}/hierarchy`),
  getUserStatistics: () => api.get('/admin/statistics'),
  getOrganizationChart: () => api.get('/admin/organization/chart'),
  
  // Reference Data
  getDepartments: () => api.get('/admin/reference/departments'),
  getTeams: () => api.get('/admin/reference/teams'),
  getManagers: () => api.get('/admin/reference/managers'),
  getEmployeeTypes: () => api.get('/admin/reference/employee-types'),
  getEmploymentStatuses: () => api.get('/admin/reference/employment-statuses'),
  getAccessLevels: () => api.get('/admin/reference/access-levels'),
};

export default userService;